import {
  Stack
} from '@mui/material'
import ButtonUnfold from '../Buttons'
import SearchField from './SearchField/SearchField'


export default function TopBar ({
  onSearchChange,
  showUnfolded = true,
  showCountChip = true,
  placeholder,
  searchFieldRef,
  isUnfolded,
  onToggleUnfolded,
}) {
  return (
    <Stack direction="row" gap={2} sx={{ maxHeight: '36px', flex: 1 }}>
      <SearchField
        ref={searchFieldRef}
        showCountChip={showCountChip}
        onChange={onSearchChange}
        placeholder={placeholder}
      />
      {
        showUnfolded && (
          <Stack direction="row" gap={1}>
            <ButtonUnfold isUnfolded={isUnfolded} onClick={onToggleUnfolded} />
          </Stack>
        )
      }

    </Stack>
  )
}
